import { OAuth } from '@moovly/clients';
import * as React from 'react';

const redirects: { [key: string]: string } = {
  'https://dashboard.moovly.com': 'https://dashboard.moovly.com/backoffice',
  'https://video-studio.internal.amadeus.com': 'https://video-studio.internal.amadeus.com/backoffice',
};
OAuth.create({
  clientId: import.meta.env.MOOVLY_APP_OAUTH_CLIENT_ID,
  redirectUri: redirects[window.location.origin] || window.location.origin,
});

const useAuth = () => {
  const [authChecked, setAuthChecked] = React.useState(false);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  React.useEffect(() => {
    OAuth.onLoggedIn = () => {
      setIsAuthenticated(true);
    };

    OAuth.onLogout = () => {
      setIsAuthenticated(false);
    };

    OAuth.isAuthenticated().then((authenticated) => {
      if (authenticated) {
        setIsAuthenticated(true);
      }
      setAuthChecked(true);
    });
  }, []);

  return { authChecked, isAuthenticated };
};

export default useAuth;
